import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const sendSafely = defineConnector({
  identifier: "sendSafely",
  name: "SendSafely",
  tagLine: "Encrypted file transfer",
  keywords: "secure file transfer encrypted packages dropzone",
  logo,
  protocol: "http",
  tags: ["documents", "security"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) =>
    headerAuth([
      { name: "ss-api-key", value: app.secret.apiKeyId },
      { name: "ss-api-secret", value: app.secret.apiKeySecret },
    ]),
  steps: [
    {
      title: "Generate API keys",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to SendSafely, open **Edit Profile**, and create a key in **API Access Keys**. Copy the API key ID and API key secret — the secret is shown only once.",
        },
      ],
    },
    {
      title: "Enter your SendSafely details",
      items: [
        {
          kind: "url",
          label: "SendSafely URL",
          required: true,
          placeholder: "https://app.sendsafely.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText:
            "The URL you use to open SendSafely, including a white-label host.",
        },
        {
          kind: "input",
          label: "API key ID",
          required: true,
          target: { kind: "secrets", field: "apiKeyId" },
        },
        {
          kind: "input",
          label: "API key secret",
          required: true,
          target: { kind: "secrets", field: "apiKeySecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => ({
      url: `${instanceUrl || "https://app.sendsafely.com"}/api/v2.0/user/`,
      expectedBodyContains: '"response":"SUCCESS"',
    }),
  },
});
